import React from "react";
import Navbar from "./Component/Navbar";
import Page11 from "./Component/Footer";
import { Outlet } from "react-router-dom";
import Footer from "./Component/Footer";
import { Container } from "reactstrap";
import "../../Homepage/Component/Homepage.css"

const MainLayout = ({ children }) => {
  return (
   <div>
      <Navbar />
      <main>
        <Outlet /> {/* This renders the child route */}
      </main>
      <Container fluid className="h-100" style={{background:"#7D178F"}} >
      <Container   style={{
    width: window.innerWidth < 500 ? "100%" : "75%"
  }} >
             <Footer />
               
      </Container>
    </Container>

    
     
    </div>
  );
};

export default MainLayout;
